module.exports = __webpack_public_path__ + "img/logo5.d56f25d1.png";